import {
  Outlet, useOutletContext,
} from 'react-router-dom';
import { UserType, useUser } from '@equifinance/shared';
import { RoutingContextType } from '.';
import { BrokerProvider } from '../contexts/broker';

const getBrokerUserId = (user: UserType) => {
  if (user && Array.isArray(user.brokerUserId)) return user.brokerUserId[0];
  return user?.brokerUserId || '';
};

export function BrokerRoutes() {
  const { user } = useUser();
  const outletValue: RoutingContextType = useOutletContext();

  const contextValue: RoutingContextType = {
    ...outletValue,
  };

  return (
    <BrokerProvider id={getBrokerUserId(user)}>
      <Outlet context={contextValue} />
    </BrokerProvider>
  );
}
